import styled from 'styled-components';

import chillImg from 'assets/brand/chill.png';

export const PhoneBookImage = styled.img.attrs({
  alt: '',
  src: chillImg,
})`
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
  height: 144px;
  width: 144px;
  margin-left: auto;
  margin-right: auto;
`;
